module.exports = __webpack_public_path__ + "images/gbi-results-logo_36d20b2.svg";